document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  if ('classList' in document.createElement('div') &&
   'querySelector' in document &&
   'addEventListener' in window && Array.prototype.forEach) {
    componentHandler.upgradeAllRegistered();
  } else {
    //
    // Dummy function to avoid JS errors.
    //
    componentHandler.upgradeElement = function () {
    };
    //
    // Dummy function to avoid JS errors.
    //
    componentHandler.register = function () {
    };
  }

  var observer = new MutationObserver(function(mutations) {
    window.componentHandler.upgradeDom();
  });
  observer.observe(document, {
    childList : true,
    subtree : true
  });
  
});